<script>
  export let ribbon
  export let active
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<svg
  on:click={() => {
    active = ribbon.id
  }}
  id={ribbon.id}
  viewBox={ribbon.viewBox}
  class="max-h-[130px] cursor-pointer {active == ribbon.id ? 'bg-slate-500' : ''} rounded-md p-2"
>
  {#each ribbon.data as path}
    <path fill={path.fill} d={path.d} />
    <!-- <path fill={path.fill} id={path.id} d={path.d} /> -->
  {/each}
</svg>
